// Shared helper: turn a (gzip-compressed) base64 string from dms_documents.file_base64
// into raw PDF bytes. Used by ProcessReceiptsTab's preview and the standalone
// DocViewerPage (open-in-new-tab).
export function decompressBase64ToBytes(base64: string): Promise<Uint8Array> {
  return new Promise((resolve, reject) => {
    try {
      const binary = atob(base64);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);

      const DS = (window as any).DecompressionStream;
      if (typeof DS !== 'undefined') {
        const ds = new DS('gzip');
        const writer = ds.writable.getWriter();
        writer.write(bytes);
        writer.close();
        const reader = ds.readable.getReader();
        const chunks: Uint8Array[] = [];
        const pump = (): Promise<void> => reader.read().then(({ done, value }: { done: boolean; value: Uint8Array }) => {
          if (done) {
            const totalLen = chunks.reduce((s, c) => s + c.length, 0);
            const result = new Uint8Array(totalLen);
            let off = 0;
            for (const c of chunks) { result.set(c, off); off += c.length; }
            resolve(result);
            return;
          }
          chunks.push(value);
          return pump();
        });
        pump().catch(reject);
      } else {
        // No DecompressionStream — assume raw PDF bytes
        resolve(bytes);
      }
    } catch (e) { reject(e); }
  });
}
